import { useContext } from "react";
import { SettingContext } from "../providers/setting";

const useSetting = () => {
  const values = useContext(SettingContext);
  return values;
};

export default useSetting;
